import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=093d88ba&scoped=true&"
import script from "./Forbidden.vue?vue&type=script&lang=js&"
export * from "./Forbidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d88ba",
  null
  
)

export default component.exports